<template>
  <div class="talk-free">
    <p class="m-0 you-need-assistance">{{
      $t(`${base}.you_need_assistance`)
    }}</p>

    <a
      v-if="isProductChatProvider"
      type="info"
      class="links-contact el-link el-link--info is-underline"
      @click="handleClickAskQuestion"
    >
      <i class="far fa-comments fa-2x" />
    </a>
    <a
      v-else
      type="info"
      class="links-contact el-link el-link--info is-underline"
      :href="showLink ? whatsappLink : ''"
      target="_blank"
      @click="handleClickWhatsapp"
    >
      <i class="fab fa-whatsapp fa-2x" />
    </a>

    <el-link
      type="info"
      class="links-contact"
      :href="contactInfo.customer_service.phone | phoneHref"
    >
      <i class="fas fa-phone-alt fa-2x" />
    </el-link>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { phoneHref, objet2qs } from '@/utils'
import LadParams from '@/utils/mixin/lad-params'
import AnalyticsWhatsappLeadMixin from '@/utils/mixin/analytics-whatsapplead'

export default {
  name: 'LadTalkFree',
  filters: { phoneHref },
  mixins: [AnalyticsWhatsappLeadMixin, LadParams],
  props: {
    base: { type: String, require: true, default: '' },
  },
  data() {
    return {
      contactInfo: { customer_service: { whatsapp: [''] } },
      showLink: false,
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      name: (state) => state.experience.name,
      /** se usa en `analytics-whatsapplead` */
      isLad: (state) => state.experience.is_lad,
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        type: state.experience.type,
      }),
    }),
    ...mapState('settings', ['locale', 'currency']),
    whatsappLink() {
      const phone = this.contactInfo.customer_service.whatsapp[0]
      const qs = objet2qs(this.params)
      const currentLink =
        qs.trim() === ''
          ? `${process.env.APP_URL}${this.$route.path}`
          : `${process.env.APP_URL}${this.$route.path}?${qs}`

      const text = this.$t(`${this.base}.whatsapp_message`, {
        name: this.name,
        link: encodeURIComponent('\n\n\n' + currentLink),
      })

      /** https://faq.whatsapp.com/452366545421244/?locale=es_ES */
      return this.isMobile
        ? `whatsapp://send?phone=${phone.replace(/ /g, '')}&text=${text}`
        : `https://wa.me/${phone.replace(/ |\+/g, '')}?text=${text}`
    },
    isProductChatProvider() {
      return process.env.PRODUCTS_CHAT_PROVIDER.includes(this.exExperience.uuid)
    },
  },
  watch: {
    locale: {
      immediate: true,
      handler(value) {
        this.contactInfo = require(`@/db/contact/${value.toLowerCase()}`).default
      },
    },
  },
  mounted() {
    /** se completa info del link con el localStorage */
    setTimeout(() => (this.showLink = true), 500)
  },
}
</script>

<style lang="scss">
.contact-section {
  text-align: center;
  padding: 20px 10px !important;

  @media (min-width: 576px) {
    padding: 20px !important;
  }

  .talk-free {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 20px;
    align-items: center;
  }

  .you-need-assistance {
    color: #329800;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 25.2px; /* 140% */
  }

  .links-contact {
    max-height: 26px;

    &:hover {
      text-decoration: none !important;
      color: #d3d4d6;

      &::after {
        content: none;
      }
    }
  }

  .img--cover {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover;
      height: 2rem;
      width: 2rem;
      border-radius: 50%;
    }
  }

  .fa-comments,
  .fa-whatsapp,
  .fa-phone-alt {
    font-size: 24px;
  }
}
</style>
